jQuery( document ).ready(function() {

  if($('.simpleheader').length > 0) {

    $(".simpleheader_link-menu-item-has-children").mouseenter(function () {
      $(this).next(".simpleheader_childrenbox").addClass('simpleheader_childrenbox-active');
      $(this).addClass('simpleheader_link-active');
    });
    $(".simpleheader_item").mouseleave(function () {
      $(this).find(".simpleheader_childrenbox").removeClass('simpleheader_childrenbox-active');
      $(this).find(".simpleheader_link").removeClass('simpleheader_link-active');
    });
    $('.simpleheader_link').focusin(function (e) {
      $(".simpleheader_childrenbox").removeClass('simpleheader_childrenbox-active');
      $('.simpleheader_link-menu-item-has-children').removeClass('simpleheader_link-active');
		});
    $('.simpleheader_link-menu-item-has-children').focusin(function (e) {
      $(".simpleheader_childrenbox").removeClass('simpleheader_childrenbox-active');
      $('.simpleheader_link-menu-item-has-children').removeClass('simpleheader_link-active');
      $(this).next(".simpleheader_childrenbox").addClass('simpleheader_childrenbox-active');
      $(this).addClass('simpleheader_link-active');
		});
    $( ".simpleheader_mobiletrigger" ).click(function() {
      $( ".simpleheader_mobilebar" ).toggleClass( "simpleheader_mobilebar-active" );
      $( ".simpleheader_mobilemenu" ).slideToggle();
    });
    $( ".simpleheader_mobilehaschild" ).click(function() {
      $(this).next(".simpleheader_mobilechildren").slideToggle();
      $(this).prev(".simpleheader_arrow").toggleClass("simpleheader_arrow-active");
      $(this).toggleClass("simpleheader_mobilehaschild-active");
    });

  }

});